<template>
	<h1 v-if="heading && headingText" class="blind">{{ headingText }}</h1>
	<p v-if="text && intro" class="site_intro">{{ intro }}</p>
</template>

<script>
import { profileForHost } from "@/lib/siteProfiles";
import { siteHostname } from "@/lib/Seo";

/**
 * 카드(호스트)별 상단 안내 문장. 브랜드 목록·상세, 매장 검색, 쇼핑 페이지 상단에 둔다.
 * 검색엔진이 서브도메인을 "같은 페이지 N벌"이 아니라 카드별 페이지로 보게 하는 본문 차별화 요소다.
 */
export default {
	name: "SiteIntro",
	props: {
		/** 페이지에 보이는 제목이 없을 때(브랜드 목록) 숨은 h1 을 함께 출력 */
		heading: { type: Boolean, default: false },
		/** false 면 안내 문장은 숨기고 h1 만 출력 (홈처럼 디자인상 문장을 둘 자리가 없을 때) */
		text: { type: Boolean, default: true },
	},
	computed: {
		intro() {
			return profileForHost(siteHostname()).intro || "";
		},
		headingText() {
			return profileForHost(siteHostname()).heading || "";
		},
	},
};
</script>
